import axios from "../../axios/axios";
import { CenikItem } from "../../ts/Cenik";
import { TGetFilteredCenik } from "../../types/server-api/cenik";
import { ILazyResultResponse } from "../../types/server-api/common";

import { APIRoutes } from "../server-api/routes";

export interface ICenikModel {
  getFilteredCenik(
    query: TGetFilteredCenik
  ): Promise<ILazyResultResponse<CenikItem[]>>;
  refreshCenik(): Promise<true>;
  getLastRefreshDate(): Promise<number>;
}

export const cenikModel: ICenikModel = {
  getFilteredCenik: async (params) => {
    const res = await axios.get<ILazyResultResponse<CenikItem[]>>(
      APIRoutes.Cenik.GetFiltered,
      {
        params,
      }
    );

    return res.data;
  },
  refreshCenik: async () => {
    const res = await axios.post<true>(APIRoutes.Cenik.Refresh);

    return res.data;
  },
  getLastRefreshDate: async () => {
    const res = await axios.get<number>(APIRoutes.Cenik.GetLastRefreshDate);

    return res.data;
  },
};
